import { FEEDBACK_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(FEEDBACK_ENDPOINT);
export default instance;
